import { render, staticRenderFns } from "./UserDropDown.vue?vue&type=template&id=4651c85c"
import script from "./UserDropDown.vue?vue&type=script&lang=js"
export * from "./UserDropDown.vue?vue&type=script&lang=js"
import style0 from "./UserDropDown.vue?vue&type=style&index=0&id=4651c85c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports